const ALLOWED_BRANCHES = new Set(['Valasaravakkam', 'Vadapalani']);

export const normalizeBranch = branch => {
  if (typeof branch !== 'string') {
    return '';
  }
  const trimmed = branch.trim();
  return ALLOWED_BRANCHES.has(trimmed) ? trimmed : '';
};

export const getSelectedBranch = () =>
  normalizeBranch(localStorage.getItem('selectedBranch') || localStorage.getItem('branch') || '');

export const withBranchPayload = payload => {
  const branch = getSelectedBranch();
  if (!branch || payload === null || payload === undefined || typeof payload !== 'object') {
    return payload;
  }
  if (Array.isArray(payload)) {
    return payload.map(item => {
      if (item !== null && typeof item === 'object' && !Array.isArray(item)) {
        const itemBranch = normalizeBranch(item.branch);
        return {
          ...item,
          branch: itemBranch || branch
        };
      }
      return item;
    });
  }
  const payloadBranch = normalizeBranch(payload.branch);
  return {
    ...payload,
    branch: payloadBranch || branch
  };
};

export const withBranchParams = params => {
  const branch = getSelectedBranch();
  
  // High priority: if skipBranchFilter is true, do not add branch param
  if (params && typeof params === 'object' && !Array.isArray(params) && params.skipBranchFilter) {
    const sanitizedParams = {...params};
    delete sanitizedParams.skipBranchFilter;
    return sanitizedParams;
  }

  if (!branch) {
    return params;
  }

  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const paramsBranch = normalizeBranch(params.branch);
    return {
      ...params,
      branch: paramsBranch || branch
    };
  }

  return {branch};
};
